/**
 * @file bin-view.ts
 * @description Общие куски подачи ячейки для карточки (`<lg`) и таблицы
 *   (`≥lg`) справочника (phase19.22 шаг 5): сводка содержимого, статус и
 *   меню «⋯». Одна формулировка — два места показа, чтобы подписи не
 *   разъезжались.
 */

import { Archive, Boxes, RotateCcw } from "lucide-react";

import type { RowAction } from "../../ui/RowActionsMenu";
import type { StorageBinDto } from "../../../lib/api-bins";

/** «2 фасовки · 18 шт» либо «Ячейка свободна»; без агрегата от API — «—». */
export function binSummaryText(bin: StorageBinDto): string {
  if (!bin.summary) return "—";
  if (bin.summary.isEmpty) return "Ячейка свободна";
  const qty = Number(bin.summary.totalQuantity).toLocaleString("ru-RU");
  return `${bin.summary.skuCount} фасовк(и) · ${qty} шт`;
}

/** Статус ячейки: бейдж «Архив» / «Пусто» / «Активна». */
export function binStatus(bin: StorageBinDto): { label: string; variant: "default" | "outline" | "primary" } {
  if (!bin.isActive) return { label: "Архив", variant: "default" };
  if (bin.summary?.isEmpty) return { label: "Пусто", variant: "outline" };
  return { label: "Активна", variant: "primary" };
}

/** Меню «⋯» ячейки: деструктивное — последним (чек-лист A6, п. 6). */
export function binRowActions(
  bin: StorageBinDto,
  handlers: { onOpen: () => void; onArchive: () => void; onRestore: () => void },
): RowAction[] {
  return [
    { key: "contents", label: "Содержимое ячейки", icon: Boxes, run: handlers.onOpen },
    bin.isActive
      ? { key: "archive", label: "В архив", icon: Archive, danger: true, run: handlers.onArchive }
      : { key: "restore", label: "Вернуть из архива", icon: RotateCcw, run: handlers.onRestore },
  ];
}
